import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Gift, ChevronDown, ClipboardList, Layers, UserCheck, Apple, PlayCircle, ListChecks, CheckCircle2, Sparkles } from 'lucide-react';
const bonos = [{
  num: 'B1',
  icon: ClipboardList,
  title: '100 Ejercicios con Diagrama',
  value: '$12.000',
  desc: 'El banco de ejercicios más completo para entrenadores de tenis. Con diagrama de cancha, nivel, materiales y objetivo en cada uno. 100 drills organizados por categoría y nivel.',
  bullets: ['100 drills con diagrama de cancha', 'Organizados por nivel y objetivo', 'Listos para imprimir y llevar a la cancha'],
  pages: '40 páginas'
}, {
  num: 'B2',
  icon: Layers,
  title: 'Banco de Drills por Nivel',
  value: '$9.000',
  desc: 'El recurso que más tiempo le ahorra al entrenador. Drills organizados por nivel, objetivo y duración. Principiante, intermedio y avanzado. Planificador de clase en 5 minutos incluido.',
  bullets: ['Drills por nivel: principiante, intermedio, avanzado', 'Filtrados por objetivo y duración', 'Planificador de clase en 5 minutos'],
  pages: '40 páginas'
}, {
  num: 'B3',
  icon: UserCheck,
  title: 'Fichas de Alumnos Editables',
  value: '$8.000',
  desc: 'Sistema completo de seguimiento individual. Fichas de evaluación técnica, táctica y física. Registro de progreso, planilla de alumnos y herramientas de comunicación listas.',
  bullets: ['Fichas técnica, táctica y física', 'Planilla de seguimiento de progreso', 'Comunicación profesional con alumnos'],
  pages: '40 páginas'
}, {
  num: 'B4',
  icon: Apple,
  title: 'Guía de Nutrición para Tenistas',
  value: '$8.000',
  desc: 'Responde las preguntas de tus alumnos con información real y profesional. Nutrición antes, durante y después del partido, hidratación, suplementación básica y planes de comida para diferentes perfiles.',
  bullets: ['Nutrición antes, durante y después del partido', 'Hidratación y suplementación básica', 'Planes de comida por perfil'],
  pages: '40 páginas'
}, {
  num: 'B5',
  icon: PlayCircle,
  title: 'Clases Modelo Listas para Dar',
  value: '$11.000',
  desc: '12 clases completas y listas para usar hoy mismo. Cada clase tiene objetivo, estructura por bloques, ejercicios con variantes, materiales necesarios y cierre con retroalimentación incluido.',
  bullets: ['12 clases completas listas para usar', 'Objetivo, bloques y variantes definidos', 'Cierre con retroalimentación'],
  pages: '40 páginas'
}, {
  num: 'B6',
  icon: ListChecks,
  title: 'Test de Nivel + Evaluación Inicial',
  value: '$8.000',
  desc: 'El protocolo completo para evaluar a cada alumno desde la primera clase. Test técnico, físico y táctico por nivel. Ficha de diagnóstico, hoja de ruta del alumno y presentación de resultados incluidos.',
  bullets: ['Test técnico, físico y táctico', 'Ficha de diagnóstico inicial', 'Hoja de ruta del alumno'],
  pages: '40 páginas'
}];
export function BonosSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-20 bg-navy-900 text-white relative overflow-hidden" data-id="element-12">
      <div className="absolute inset-0 bg-court-pattern opacity-30" data-id="element-13"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-optic/10 blur-[120px] rounded-full pointer-events-none" data-id="element-14"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-15">
        <div className="text-center mb-10 md:mb-14" data-id="element-16">
          <span className="inline-flex items-center gap-2 py-1.5 px-3 rounded-full bg-optic/15 border border-optic/30 text-optic text-[10px] md:text-xs font-bold tracking-wider uppercase mb-4" data-id="element-17">
            <Sparkles className="w-3.5 h-3.5" data-id="element-18" /> Sin costo extra — incluidos en
            todas las ofertas
          </span>
          <h2 className="text-3xl md:text-5xl font-display text-optic mb-3 md:mb-4" data-id="element-19">
            INCLUIDOS GRATIS
          </h2>
          <p className="text-base md:text-xl text-gray-300 font-medium max-w-2xl mx-auto" data-id="element-20">
            6 Bonos Estratégicos para acelerar tu trabajo
          </p>
          <p className="text-xs md:text-sm text-gray-400 mt-3" data-id="element-21">
            Tocá cada bono para ver su contenido ↓
          </p>
        </div>

        <div className="space-y-3 md:space-y-4" data-id="element-22">
          {bonos.map((bono, i) => {
          const isOpen = openIndex === i;
          const Icon = bono.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className={`relative rounded-2xl overflow-hidden transition-all ${isOpen ? 'bg-navy-800 border-2 border-optic/50 shadow-glow' : 'bg-navy-800 border border-navy-700 hover:border-optic/30 hover:-translate-y-0.5'}`} data-id="element-23">
                {/* Optic accent stripe */}
                <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-optic" data-id="element-24"></div>

                {/* GRATIS ribbon */}
                <div className="absolute -top-1 right-4 md:right-6 z-20 pointer-events-none" data-id="element-25">
                  <div className="relative bg-terracotta text-white text-[10px] md:text-xs font-display tracking-wider uppercase px-3 py-1.5 shadow-lg rounded-b-md" data-id="element-26">
                    <span className="flex items-center gap-1" data-id="element-27">
                      <Sparkles className="w-3 h-3" data-id="element-28" />
                      GRATIS
                    </span>
                  </div>
                </div>

                <button onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="w-full flex items-center gap-3 md:gap-5 p-4 md:p-6 pl-5 md:pl-8 pr-4 md:pr-6 text-left" data-id="element-29">
                  {/* Number + icon stack */}
                  <div className="relative flex-shrink-0" data-id="element-30">
                    <div className="w-14 h-14 md:w-16 md:h-16 bg-optic text-navy-900 font-display text-xl md:text-2xl rounded-xl flex items-center justify-center shadow-lg" data-id="element-31">
                      {bono.num}
                    </div>
                    <div className="absolute -bottom-1.5 -right-1.5 w-7 h-7 md:w-8 md:h-8 bg-navy-900 rounded-lg flex items-center justify-center shadow-md ring-2 ring-optic" data-id="element-32">
                      <Icon className="w-3.5 h-3.5 md:w-4 md:h-4 text-optic" data-id="element-33" />
                    </div>
                  </div>

                  <div className="flex-1 min-w-0 pr-12 md:pr-14" data-id="element-34">
                    <h3 className="text-base md:text-lg font-display text-white leading-tight" data-id="element-35">
                      {bono.title}
                    </h3>
                    <div className="flex items-center flex-wrap gap-2 md:gap-3 mt-1.5" data-id="element-36">
                      <span className="text-[11px] md:text-xs text-gray-400 line-through" data-id="element-37">
                        Valor {bono.value}
                      </span>
                      <span className="text-[10px] md:text-xs font-bold uppercase tracking-wider text-optic bg-optic/10 px-2 py-0.5 rounded-md" data-id="element-38">
                        {bono.pages}
                      </span>
                    </div>
                  </div>

                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className={`flex-shrink-0 w-9 h-9 md:w-10 md:h-10 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-optic text-navy-900' : 'bg-navy-700 text-optic'}`} data-id="element-39">
                    <ChevronDown className="w-5 h-5" data-id="element-40" />
                  </motion.div>
                </button>

                <AnimatePresence initial={false} data-id="element-41">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-42">
                      <div className="px-5 md:px-8 pb-6 md:pb-7" data-id="element-43">
                        <p className="text-gray-300 text-sm md:text-base mb-4 leading-relaxed" data-id="element-44">
                          {bono.desc}
                        </p>

                        <div className="space-y-2 mb-4" data-id="element-45">
                          <p className="text-[11px] md:text-xs font-bold text-optic uppercase tracking-wider mb-2" data-id="element-46">
                            Incluye:
                          </p>
                          {bono.bullets.map((b, idx) => <div key={idx} className="flex items-start gap-2.5" data-id="element-47">
                              <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-optic flex-shrink-0 mt-0.5" data-id="element-48" />
                              <span className="text-sm md:text-base text-gray-200" data-id="element-49">
                                {b}
                              </span>
                            </div>)}
                        </div>

                        <div className="flex items-center justify-between gap-3 pt-3 border-t border-navy-700" data-id="element-50">
                          <div className="flex items-center gap-2 text-optic text-[11px] md:text-xs font-bold uppercase" data-id="element-51">
                            <Gift className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-52" />
                            {bono.pages} listas para usar
                          </div>
                          <div className="text-right" data-id="element-53">
                            <span className="text-[10px] md:text-xs text-gray-400 line-through block leading-none" data-id="element-54">
                              {bono.value}
                            </span>
                            <span className="text-[10px] md:text-xs font-display text-terracotta uppercase tracking-wider" data-id="element-55">
                              Hoy gratis
                            </span>
                          </div>
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        <div className="mt-10 md:mt-16 text-center" data-id="element-56">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative inline-block" data-id="element-57">
            <div className="absolute inset-0 bg-optic/30 blur-2xl rounded-2xl" data-id="element-58"></div>
            <div className="relative bg-terracotta text-white border-2 border-white/20 rounded-2xl p-5 md:p-7 shadow-2xl" data-id="element-59">
              <p className="text-[10px] md:text-xs font-bold uppercase tracking-widest text-white/80 mb-2" data-id="element-60">
                Valor real de los 6 bonos
              </p>
              <h3 className="text-2xl md:text-4xl font-display uppercase tracking-wide leading-tight" data-id="element-61">
                <span className="line-through text-white/60 text-xl md:text-3xl" data-id="element-62">
                  $56.000
                </span>
                <br className="md:hidden" data-id="element-63" />
                <span className="text-optic ml-0 md:ml-3" data-id="element-64">→ HOY GRATIS</span>
              </h3>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}